import Vue from 'vue'
import VueRouter from 'vue-router'
import App from './App.vue'
import createRouter from './router'
import store from '@/store/index.js'


Vue.use(VueRouter)


Vue.config.productionTip = false

//atoms
import AppButton from '@/components/atoms/AppButton.vue'
import AppErrorList from '@/components/atoms/AppErrorList.vue'
import AppRadio from '@/components/atoms/AppRadio.vue'
import AppRadioSubBox from '@/components/atoms/AppRadioSubBox.vue'
import AppText from '@/components/atoms/AppText.vue'
import HelpButton from '@/components/atoms/HelpButton.vue'
import InformationBox from '@/components/atoms/InformationBox.vue'
import LinkButton from '@/components/atoms/LinkButton.vue'
import PartsArrow from '@/components/atoms/PartsArrow.vue'
import SearchButton from '@/components/atoms/SearchButton.vue'
import SelectedHotWaterTable from '@/components/atoms/SelectedHotWaterTable.vue'
import SelectedCogenTable from '@/components/atoms/SelectedCogenTable.vue'

//molecules

//organisms
import AppBox from '@/components/organisms/AppBox.vue'
import AppSection from '@/components/organisms/AppSection.vue'
import AppGridInBox from '@/components/organisms/AppGridInBox.vue'
import InfoSection from '@/components/organisms/InfoSection.vue'
import Help from '@/components/organisms/Help.vue'

//templates
import BadRequest from '@/components/templates/BadRequest.vue'
import Confirm from '@/components/templates/Confirm.vue'
import LayoutHeader from '@/components/templates/LayoutHeader.vue'
import ModalError from '@/components/templates/ModalError.vue'
import ModalLoadingSpin from '@/components/templates/ModalLoadingSpin.vue'
import ModalLoad from '@/components/templates/ModalLoad.vue'
import ModalLoadingShort from '@/components/templates/ModalLoadingShort.vue'
import ModalSave from '@/components/templates/ModalSave.vue'
import ModalSearchResult from '@/components/templates/ModalSearchResult.vue'
import ModalSimpleToDetail from '@/components/templates/ModalSimpleToDetail.vue'
import NotFound from '@/components/templates/NotFound.vue'

Vue.component('modal-error', ModalError)
Vue.component('modal-loading-spin', ModalLoadingSpin)
Vue.component('modal-load', ModalLoad)
Vue.component('modal-loading-short', ModalLoadingShort)
Vue.component('modal-save', ModalSave)
Vue.component('modal-search-result', ModalSearchResult)
Vue.component('modal-simple-to-detail', ModalSimpleToDetail)
Vue.component('confirm', Confirm)
Vue.component('bad-request', BadRequest)
Vue.component('not-found', NotFound)
Vue.component('layout-header', LayoutHeader)
Vue.component('app-section', AppSection)
Vue.component('info-section', InfoSection)
Vue.component('app-box', AppBox)
Vue.component('app-grid-in-box', AppGridInBox)
Vue.component('app-radio', AppRadio)
Vue.component('app-text', AppText)
Vue.component('app-button', AppButton)
Vue.component('app-error-list', AppErrorList)
Vue.component('app-radio-sub-box', AppRadioSubBox)
Vue.component('parts-arrow', PartsArrow)
Vue.component('search-button', SearchButton)
Vue.component('help', Help)
Vue.component('help-button', HelpButton)
Vue.component('link-button', LinkButton)
Vue.component('selected-hot-water-table', SelectedHotWaterTable)
Vue.component('selected-cogen-table', SelectedCogenTable)
Vue.component('information-box', InformationBox)

const router = createRouter()

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
